<!-- src/components/admin/KnowledgePerformanceDialog.vue -->
<template>
  <el-dialog
    title="知识库文档表现报表"
    :visible.sync="dialogVisible"
    width="1300px"
    append-to-body
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <!-- 筛选条件栏 -->
    <div class="filter-bar">
      <el-date-picker
        v-model="dateRange"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        size="small"
        value-format="yyyy-MM-dd"
        :picker-options="pickerOptions"
        style="width: 280px;"
        @change="onDateChange"
      />

      <!-- el-input
        v-model="keyword"
        placeholder="搜索文档标题关键词"
        size="small"
        clearable
        style="width: 220px; margin-left: 12px;"
        @keyup.enter.native="onSearch"
        @clear="onSearch"
      >
        <i slot="prefix" class="el-icon-search" />
      </el-input -->

      <el-button type="primary" size="small" @click="onSearch" style="margin-left: 12px;">
        <svg t="1785413371333" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1673" width="16" height="16"><path d="M444.416 198.656c65.7408 0 127.3856 25.6 173.8752 71.8848 46.4896 46.4896 71.8848 108.1344 71.8848 173.8752s-25.6 127.3856-71.8848 173.8752S510.1568 690.176 444.416 690.176c-65.7408 0-127.3856-25.6-173.8752-71.8848C224.256 571.8016 198.656 510.1568 198.656 444.416s25.6-127.3856 71.8848-173.8752S378.6752 198.656 444.416 198.656m0-45.056c-74.3424 0-148.8896 28.4672-205.6192 85.1968-113.664 113.664-113.664 297.7792 0 411.2384C295.5264 706.7648 370.0736 735.232 444.416 735.232s148.8896-28.4672 205.6192-85.1968c113.664-113.664 113.664-297.7792 0-411.2384C593.3056 182.0672 518.7584 153.6 444.416 153.6z" fill="#ffffff" p-id="1674"></path><path d="M267.0592 439.5008c-1.6384 0-3.2768-0.2048-4.9152-0.6144-12.0832-2.6624-19.8656-14.7456-16.9984-26.8288 9.216-40.7552 29.696-78.0288 59.392-107.7248 19.8656-19.8656 42.8032-35.4304 68.4032-46.4896 11.4688-4.9152 24.7808 0.2048 29.696 11.6736s-0.2048 24.7808-11.6736 29.696c-20.2752 8.8064-38.5024 21.2992-54.272 37.0688-23.552 23.552-39.936 53.248-47.3088 85.8112-2.6624 10.4448-12.0832 17.408-22.3232 17.408z" fill="#ffffff" p-id="1675"></path><path d="M822.0672 854.016L620.544 652.288c-8.8064-8.8064-8.8064-23.1424 0-31.9488 8.8064-8.8064 23.1424-8.8064 31.9488 0l201.728 201.728c8.8064 8.8064 8.8064 23.1424 0 31.9488-9.0112 8.8064-23.3472 8.8064-32.1536 0z" fill="#ffffff" p-id="1676"></path></svg>
         查询
      </el-button>

      <el-button size="small" @click="handleExport">
         <svg t="1785417034535" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5633" width="16" height="16"><path d="M810.666667 426.666667c-25.6 0-42.666667 17.066667-42.666667 42.666666v341.333334c0 25.6-17.066667 42.666667-42.666667 42.666666H298.666667c-25.6 0-42.666667-17.066667-42.666667-42.666666V213.333333c0-25.6 17.066667-42.666667 42.666667-42.666666h170.666666c25.6 0 42.666667-17.066667 42.666667-42.666667s-17.066667-42.666667-42.666667-42.666667H298.666667C226.133333 85.333333 170.666667 140.8 170.666667 213.333333v597.333334c0 72.533333 55.466667 128 128 128h426.666666c72.533333 0 128-55.466667 128-128v-341.333334c0-25.6-17.066667-42.666667-42.666666-42.666666z" fill="#1296db" p-id="5634"></path><path d="M755.2 85.333333H640c-25.6 0-42.666667 17.066667-42.666667 42.666667s17.066667 42.666667 42.666667 42.666667h51.2L469.333333 392.533333c-17.066667 17.066667-17.066667 46.933333 0 64 17.066667 17.066667 42.666667 17.066667 59.733334 0L768 213.333333v85.333334c0 25.6 17.066667 42.666667 42.666667 42.666666s42.666667-17.066667 42.666666-42.666666V183.466667C853.333333 132.266667 806.4 85.333333 755.2 85.333333zM384 682.666667h256c25.6 0 42.666667-17.066667 42.666667-42.666667s-17.066667-42.666667-42.666667-42.666667H384c-25.6 0-42.666667 17.066667-42.666667 42.666667s17.066667 42.666667 42.666667 42.666667z" fill="#1296db" p-id="5635"></path></svg>
         导出
      </el-button>

      <span style="margin-left: 16px; color: #909399; font-size: 13px;">
        共 {{ total }} 条记录
      </span>
    </div>

    <!-- 表格 -->
    <el-table
      ref="performanceTable"
      :data="tableData"
      v-loading="loading"
      border
      stripe
      style="width: 100%; margin-top: 12px;"
      max-height="520"
      @sort-change="onSortChange"
    >
      <el-table-column type="index" label="序号" width="55" align="center" />

      <el-table-column
        prop="docTitle"
        label="文档标题"
        min-width="200"
        show-overflow-tooltip
      >
        <template slot-scope="{ row }">
          <span>{{ row.docTitle || '-' }}</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="docType"
        label="文档类型"
        width="100"
        align="center"
      >
        <template slot-scope="{ row }">
          <el-tag :type="row.docType === 'DOC' ? 'primary' : 'success'" size="mini">
            {{ row.docType === 'DOC' ? '图文文档' : '问答对' }}
          </el-tag>
        </template>
      </el-table-column>

      <el-table-column
        prop="hitCount"
        label="命中次数"
        width="120"
        align="center"
        sortable="custom"
      >
        <template slot-scope="{ row }">
          <span class="hit-count">{{ row.hitCount }}</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="uniqueUsers"
        label="使用用户数"
        width="120"
        align="center"
      >
        <template slot-scope="{ row }">
          <span>{{ row.uniqueUsers || 0 }}</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="avgConfidence"
        label="平均置信度"
        width="130"
        align="center"
        sortable="custom"
      >
        <template slot-scope="{ row }">
          <span
            class="confidence-tag"
            :class="getConfidenceClass(row.avgConfidence)"
          >
            {{ formatConfidence(row.avgConfidence) }}
          </span>
        </template>
      </el-table-column>

      <el-table-column
        prop="maxConfidence"
        label="最高置信度"
        width="130"
        align="center"
      >
        <template slot-scope="{ row }">
          <span>{{ formatConfidence(row.maxConfidence) }}</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="percentage"
        label="占比"
        width="200"
        align="center"
        sortable="custom"
      >
        <template slot-scope="{ row }">
          <div class="percentage-wrapper">
            <el-progress
              :percentage="row.percentage"
              :stroke-width="8"
              :color="getPercentageColor(row.percentage)"
              :format="percentageFormat"
            />
          </div>
        </template>
      </el-table-column>

      <el-table-column
        prop="lastHitTime"
        label="最后命中时间"
        width="170"
        align="center"
      >
        <template slot-scope="{ row }">
          {{ formatLastHitTime(row.lastHitTime)}}
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <div class="pagination-wrapper">
      <el-pagination
        @size-change="onSizeChange"
        @current-change="onPageChange"
        :current-page="page + 1"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      />
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">关 闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getKnowledgePerformance } from '@/api/dashboard'
import { formatToBeijingTime } from '@/util/date';

export default {
  name: 'KnowledgePerformanceDialog',
  data() {
    return {
      dialogVisible: false,
      loading: false,
      tableData: [],
      total: 0,
      page: 0,
      size: 20,
      dateRange: this.getDefaultDateRange(),
      documentType: null,
      keyword: '',
      sortField: 'hitCount',
      sortDirection: 'DESC',
      pickerOptions: {
        shortcuts: [
          { text: '近7天', onClick: (picker) => {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }},
          { text: '近30天', onClick: (picker) => {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }},
          { text: '近90天', onClick: (picker) => {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }}
        ]
      }
    }
  },
  computed: {
    tenantId() {
      return this.$store.getters['auth/currentTenant']?.tenantId || null
    }
  },
  methods: {
  formatLastHitTime(time) {
    if (!time) return '-'
    return formatToBeijingTime(time)
  },  
    open() {
      this.dialogVisible = true
      this.page = 0
      this.dateRange = this.getDefaultDateRange()
      this.documentType = null
      this.keyword = ''
      this.sortField = 'hitCount'
      this.sortDirection = 'DESC'
      this.loadData()
    },
    close() {
      this.dialogVisible = false
    },
    handleClose() {
      this.dialogVisible = false
    },
    getDefaultDateRange() {
      const end = new Date()
      const start = new Date()
      start.setDate(start.getDate() - 30)
      return [this.formatDate(start), this.formatDate(end)]
    },
    formatDate(date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    onDateChange() {
      this.page = 0
      this.loadData()
    },
    onSearch() {
      this.page = 0
      this.loadData()
    },
    onSortChange({ prop, order }) {
      if (order === 'ascending') {
        this.sortField = prop
        this.sortDirection = 'ASC'
      } else if (order === 'descending') {
        this.sortField = prop
        this.sortDirection = 'DESC'
      } else {
        // 取消排序时恢复默认
        this.sortField = 'hitCount'
        this.sortDirection = 'DESC'
      }
      this.page = 0
      this.loadData()
    },
    onPageChange(page) {
      this.page = page - 1
      this.loadData()
    },
    onSizeChange(size) {
      this.size = size
      this.page = 0
      this.loadData()
    },

    formatConfidence(value) {
      if (value === null || value === undefined) return '-'
      return (value * 100).toFixed(1) + '%'
    },

    getConfidenceClass(value) {
      if (value === null || value === undefined) return ''
      if (value >= 0.8) return 'confidence-high'
      if (value >= 0.5) return 'confidence-medium'
      return 'confidence-low'
    },

    getPercentageColor(percentage) {
      if (percentage >= 30) return '#67c23a'
      if (percentage >= 10) return '#e6a23c'
      return '#909399'
    },

    percentageFormat(percentage) {
      return percentage.toFixed(1) + '%'
    },

    async loadData() {
      if (!this.tenantId) {
        this.$message.warning('请先登录')
        return
      }

      this.loading = true
      try {
        const params = {
          tenantId: this.tenantId,
          startTime: this.dateRange[0] + ' 00:00:00',
          endTime: this.dateRange[1] + ' 23:59:59',
          page: this.page,
          size: this.size,
          documentType: this.documentType || '',
          keyword: this.keyword || '',
          sortField: this.sortField,
          sortDirection: this.sortDirection
        }

        const res = await getKnowledgePerformance(params)
        console.log("getKnowledgePerformance", res)

        if (res?.data?.code === 200) {
          const data = res.data.data
          console.log(" res.data.data.data", data)
          this.tableData = data?.content || []
          this.total = data?.number_of_elements || 0
          this.page = data?.pageable?.number || 0
        } else {
          this.$message.error(res?.data?.message || '加载失败')
          this.tableData = []
          this.total = 0
        }
      } catch (error) {
        console.error('加载知识库文章表现数据失败:', error)
        this.$message.error('加载失败: ' + (error.message || '未知错误'))
        this.tableData = []
        this.total = 0
      } finally {
        this.loading = false
      }
    },

    async handleExport() {
      if (!this.tenantId) {
        this.$message.warning('请先登录')
        return
      }

      try {
        const params = {
          tenantId: this.tenantId,
          startTime: this.dateRange[0] + ' 00:00:00',
          endTime: this.dateRange[1] + ' 23:59:59',
          documentType: this.documentType || '',
          keyword: this.keyword || '',
          sortField: this.sortField,
          sortDirection: this.sortDirection
        }

        // 导出接口暂时复用查询接口，前端生成 Excel
        const res = await getKnowledgePerformance({
          ...params,
          page: 0,
          size: 9999 // 一次性导出全部
        })

        if (res?.data?.code === 200) {
          const data = res.data.data?.content || []
          if (data.length === 0) {
            this.$message.warning('没有数据可导出')
            return
          }

          // 简单导出为 CSV（如需 Excel 可使用 xlsx 库）
          this.exportToCSV(data)
        } else {
          this.$message.error(res?.data?.message || '导出失败')
        }
      } catch (error) {
        console.error('导出失败:', error)
        this.$message.error('导出失败，请重试')
      }
    },

    exportToCSV(data) {
      const headers = ['文档标题', '文档类型', '命中次数', '使用用户数', '平均置信度', '最高置信度', '占比(%)', '最后命中时间']
      const rows = data.map(item => [
        item.docTitle || '',
        item.docType === 'DOC' ? '图文文档' : '问答对',
        item.hitCount || 0,
        item.uniqueUsers || 0,
        (item.avgConfidence ? (item.avgConfidence * 100).toFixed(1) : '') + '%',
        (item.maxConfidence ? (item.maxConfidence * 100).toFixed(1) : '') + '%',
        (item.percentage || 0).toFixed(1),
        this.formatLastHitTime(item.lastHitTime) || ''
      ])

      let csv = headers.join(',') + '\n'
      rows.forEach(row => {
        csv += row.map(v => `"${v}"`).join(',') + '\n'
      })

      const blob = new Blob(['\uFEFF' + csv], { type: 'text/csv;charset=utf-8;' })
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = `知识库文档表现报表_${this.formatDate(new Date())}.csv`
      link.click()
      URL.revokeObjectURL(link.href)

      this.$message.success('导出成功')
    }
  }
}
</script>

<style scoped>
.filter-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
}

.pagination-wrapper {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
}

::v-deep .el-dialog__body {
  padding: 20px 20px 10px 20px;
}

/* 命中次数高亮 */
.hit-count {
  font-weight: 600;
  color: #409EFF;
}

/* 置信度颜色标签 */
.confidence-tag {
  display: inline-block;
  padding: 2px 10px;
  border-radius: 12px;
  font-size: 13px;
  font-weight: 500;
}

.confidence-high {
  background-color: #f0f9eb;
  color: #67c23a;
}

.confidence-medium {
  background-color: #fdf6ec;
  color: #e6a23c;
}

.confidence-low {
  background-color: #fef0f0;
  color: #f56c6c;
}

/* 占比进度条 */
.percentage-wrapper {
  padding: 4px 8px;
}

::v-deep .el-progress-bar__inner {
  border-radius: 4px;
}

/* 分页器样式统一 */
::v-deep .el-pagination .btn-prev .el-icon,
::v-deep .el-pagination .btn-next .el-icon,
::v-deep .el-pagination .el-icon-arrow-left,
::v-deep .el-pagination .el-icon-arrow-right {
  display: none !important;
}

::v-deep .el-pagination .btn-prev {
  position: relative;
}
::v-deep .el-pagination .btn-prev::after {
  content: '<' !important;
  font-size: 14px !important;
  font-family: sans-serif !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #606266;
}

::v-deep .el-pagination .btn-next {
  position: relative;
}
::v-deep .el-pagination .btn-next::after {
  content: '>' !important;
  font-size: 14px !important;
  font-family: sans-serif !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #606266;
}

::v-deep .el-input__clear {
  display: none !important;
}

::v-deep .el-input__prefix {
  display: flex !important;
  align-items: center !important;
  left: 5px !important;
}
</style>